import { HistoryAPIData, HistoryTableData } from './types';

const getDynamicFileSize = (size: number): string => {
  if (size > 1000000) {
    return `${(size / 1024 / 1024).toFixed(1)} MB`;
  }
  return `${(size / 1024).toFixed(2)} KB`;
};

export const getTitleFromHeader = (header: string) => {
  const match = 'filename=';
  const start = header.indexOf(match);
  const name = header.slice(start + match.length + 1, header.length - 1);
  return name;
};

const statusMap = {
  SUCCESS: 'Completed',
  PARTIAL_SUCCESS: 'Completed with errors',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
  IN_PROGRESS: 'In progress',
};

const displayEntityType = {
  DEVICE: 'Devices (new)',
  TEAM: 'Teams (new)',
  LOCATION: 'Locations (new)',
  USER: 'Users (new)',
  DEVICE_UPDATE: 'Device (edit)',
  TEAM_UPDATE: 'Team (edit)',
  LOCATION_UPDATE: 'Locations (locations)',
  USER_UPDATE: 'Users (edit)',
};

export const formatJobHistory = (job: HistoryAPIData): HistoryTableData => {
  const createdBy = `${job?.createdBy?.firstName ?? ''} ${
    job?.createdBy?.lastName ?? ''
  }`;
  const lastModifiedBy = `${job?.lastModifiedBy?.firstName ?? ''} ${
    job?.lastModifiedBy?.lastName ?? ''
  }`;

  return {
    ...job,
    entityType: displayEntityType[job.entityType],
    status: statusMap[job.status],
    fileDisplay: getDynamicFileSize(job.fileSize),
    createdBy,
    lastModifiedBy,
  };
};
